import { render } from "./CreateTrainerModal.vue?vue&type=template&id=3c0408eb&scoped=true"
import script from "./CreateTrainerModal.vue?vue&type=script&lang=js"
export * from "./CreateTrainerModal.vue?vue&type=script&lang=js"

import "./CreateTrainerModal.vue?vue&type=style&index=0&id=3c0408eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0408eb"]])

export default __exports__